module.exports = __webpack_public_path__ + "img/notice.aa498fc7.gif";